module.exports = __webpack_public_path__ + "static/img/auto-hide.6bfdba4e.png";